import { BaseCommand } from "@crunchdao/shared-cli";
import { StakingClient, Network } from "@crunchdao/sdk";
import chalk from "chalk";

export class ClaimCommand extends BaseCommand {
  async execute(): Promise<void> {
    try {
      this.displayAction("Claiming rewards from all coordinators");

      const stakingClient = new StakingClient({
        connection: this.provider.connection,
        wallet: this.provider.wallet,
        network: this.network as Network,
      });

      const signature = await stakingClient.claimRewards();

      if (!signature) {
        console.log(chalk.yellow("No rewards to claim"));
        return;
      }

      if (this.resolvedOptions.output === "json") {
        this.output({
          signature: signature,
        });
      } else {
        console.log(chalk.green.bold(`\n✅ Rewards claimed successfully`));
        console.log(`  Transaction: ${chalk.gray(signature)}`);
        console.log();
      }
    } catch (error) {
      console.error("❌ Error claiming rewards:", error);
      throw error;
    }
  }
}
